$(document).ready(function() {
  $(".average_time_chart").each(function(){
    average_time_chart($(this)[0]);
  });
});

function round_scale(x) {
  return Math.ceil(x / 30) * 30;
}

function average_time_chart(element){

  var ctx = element

  var data = $(".average_time_data").data("chart");
  var fontSize;

  if(data.labels.length > 15) {
    fontSize = 0.01;
  } else {
    fontSize = 10;
  }
  var yMax;

  var d = data.datasets.map(function(dataset){ return dataset.data }).flat();

  yMax = Math.max.apply(Math, d) * 1.5;

  if(yMax == 0) { yMax = 300;}


  var my_average_time_chart = new Chart(ctx, {
    type: 'bar',
    data: data,

    options: {
      // tooltips: {
      //   enabled: false
      // },
      plugins: {
        labels: {
          fontColor: '#000',
          fontSize: fontSize,
          render: 'value'
        }
      },
      scales: {
          yAxes: [{
              ticks: {
                  min: 0,
                  max: round_scale(yMax),
                  stepSize: (round_scale(yMax))/5
              }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
          }],
      },
      legend: {
        display: false
      }
    }
  });
}